import {Component, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AdminPanelState} from '../../../store/reducers/admin-panel.reducer';
import {AdminPanelConfig} from '../../../admin-panel.config';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FieldDefinition} from '@shared/models/field-definition';

@Component({
    standalone: false,
    selector: 'lib-email-cell-viewer',
  templateUrl: './email-cell-viewer.component.html',
  styleUrls: ['./email-cell-viewer.component.scss']
})
export class EmailCellViewerComponent implements CellComponent {
  fieldDefinition: FieldDefinition;
  invalidateSubject: InvalidateSubject;
  item: any;
  sourceType: string;
  valueChanged: EventEmitter<any>;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private store: Store<AdminPanelState>) {}

  redirectToDetail() {
    const userName = this.item.cells.Username.value;
    this.router.navigate(AdminPanelConfig.DetailUserUrl(userName), {relativeTo: this.activatedRoute.parent});
  }

}
